import {Component, inject, OnInit, signal, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Params, RouterLink} from '@angular/router';
import {ApiService} from '../_services/api.service';
import {lastValueFrom} from 'rxjs';

@Component({
    selector: 'app-additional-signer',
    templateUrl: './additional-signer.component.html',
    imports: [
        RouterLink
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './additional-signer.component.scss'
})
export class AdditionalSignerComponent implements OnInit {
  documentId: string;
  error = signal<string>(null);

  private route = inject(ActivatedRoute);
  private apiService = inject(ApiService);

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      if (params.documentId) {
        this.documentId = params.documentId;
        this.handleReroute().then();
      }
    });
  }

  async handleReroute(): Promise<void> {
    try {
      const url = await lastValueFrom(this.apiService.secondSignerAccessLink(this.documentId));
      window.location.href = url.link;
    } catch (error) {
      if (error.status === 400) {
        this.error.set('There was an error generating the access link.');
      } else if (error.status > 500) {
        this.error.set('There was an error generating the access link. Please try again later.');
      }

      console.error('Error generating access link:', error);
    }
  }
}
